export default "__VITE_ASSET__CEA3xvyw__"